import React, { useEffect, useState } from 'react';
import Lightbox from './Lightbox';

const ImageGallery = () => {
        const [lightboxOpen, setLightboxOpen] = useState(false);
        const [startIndex, setStartIndex] = useState(0);

        const images = [
                'images/gallery-1.jpg',
                'images/gallery-2.jpg',
                'images/gallery-3.jpg',
                'images/gallery-4.jpg',
                'images/gallery-5.jpg',
                'images/gallery-6.jpg',
                'images/gallery-7.jpg',
                'images/gallery-8.jpg',
                'images/gallery-9.jpg',
        ];

        const openLightbox = (i) => {
                setStartIndex(i);
                setLightboxOpen(true);
        };

        const closeLightbox = () => setLightboxOpen(false);

        // Client-side protections within the gallery section
        useEffect(() => {
                const container = document.querySelector('.page-gallery');

                const preventContextMenu = (e) => {
                        // Block right-click within gallery images/thumbnails
                        e.preventDefault();
                };

                const preventDragStart = (e) => {
                        // Block drag-and-drop of images
                        e.preventDefault();
                };

                const preventKeyShortcuts = (e) => {
                        const key = e.key.toLowerCase();
                        if ((e.ctrlKey || e.metaKey) && (key === 's' || key === 'c')) {
                                e.preventDefault();
                                e.stopPropagation();
                        }
                };

                if (container) {
                        container.addEventListener('contextmenu', preventContextMenu);
                        container.addEventListener('dragstart', preventDragStart);
                }
                document.addEventListener('keydown', preventKeyShortcuts);

                return () => {
                        if (container) {
                                container.removeEventListener('contextmenu', preventContextMenu);
                                container.removeEventListener('dragstart', preventDragStart);
                        }
                        document.removeEventListener('keydown', preventKeyShortcuts);
                };
        }, []);

        return (
        <>
            {/* Photo Gallery Section Start */}
            <div className="page-gallery">
                <div className="container">
                    {/* gallery section start */}
                    <div className="row gallery-items page-gallery-box">
                        <div className="col-lg-4 col-6">
                            {/* image gallery start */}
                            <div className="photo-gallery wow fadeInUp" data-cursor-text="View">
                                <a href="#!" onClick={(e) => { e.preventDefault(); openLightbox(0); }}>
                                    <figure className="image-anime protect-wrap">
<img src="images/gallery-1.jpg" alt="Modern home interior design" draggable={false} className="protect-img" onContextMenu={(e)=>e.preventDefault()} onDragStart={(e)=>e.preventDefault()} />
                                        <div className="image-protect-overlay" role="presentation" aria-hidden="true" onContextMenu={(e)=>e.preventDefault()} onMouseDown={(e)=>e.preventDefault()} onTouchStart={(e)=>e.preventDefault()} />
                                    </figure>
                                </a>
                            </div>
                            {/* image gallery end */}
                        </div>
                        <div className="col-lg-4 col-6">
                            {/* image gallery start */}
                            <div
                                className="photo-gallery wow fadeInUp"
                                data-wow-delay="0.2s"
                                data-cursor-text="View"
                            >
                                <a href="#!" onClick={(e) => { e.preventDefault(); openLightbox(1); }}>
                                    <figure className="image-anime protect-wrap">
                                        <img src="images/gallery-2.jpg" alt="Luxury living room interior design" draggable={false} className="protect-img" onContextMenu={(e)=>e.preventDefault()} onDragStart={(e)=>e.preventDefault()} />
                                        <div className="image-protect-overlay" role="presentation" aria-hidden="true" onContextMenu={(e)=>e.preventDefault()} onMouseDown={(e)=>e.preventDefault()} onTouchStart={(e)=>e.preventDefault()} />
                                    </figure>
                                </a>
                            </div>
                            {/* image gallery end */}
                        </div>
                        <div className="col-lg-4 col-6">
                            {/* image gallery start */}
                            <div
                                className="photo-gallery wow fadeInUp"
                                data-wow-delay="0.4s"
                                data-cursor-text="View"
                            >
                                <a href="#!" onClick={(e) => { e.preventDefault(); openLightbox(2); }}>
                                    <figure className="image-anime protect-wrap">
                                        <img src="images/gallery-3.jpg" alt="Modern modular kitchen interior design"draggable={false} className="protect-img" onContextMenu={(e)=>e.preventDefault()} onDragStart={(e)=>e.preventDefault()} />
                                        <div className="image-protect-overlay" role="presentation" aria-hidden="true" onContextMenu={(e)=>e.preventDefault()} onMouseDown={(e)=>e.preventDefault()} onTouchStart={(e)=>e.preventDefault()} />
                                    </figure>
                                </a>
                            </div>
                            {/* image gallery end */}
                        </div>
                        <div className="col-lg-4 col-6">
                            {/* image gallery start */}
                            <div
                                className="photo-gallery wow fadeInUp"
                                data-wow-delay="0.6s"
                                data-cursor-text="View"
                            >
                                <a href="#!" onClick={(e) => { e.preventDefault(); openLightbox(3); }}>
                                    <figure className="image-anime protect-wrap">
                                        <img src="images/gallery-4.jpg" alt="Stylish bedroom interior design" draggable={false} className="protect-img" onContextMenu={(e)=>e.preventDefault()} onDragStart={(e)=>e.preventDefault()} />
                                        <div className="image-protect-overlay" role="presentation" aria-hidden="true" onContextMenu={(e)=>e.preventDefault()} onMouseDown={(e)=>e.preventDefault()} onTouchStart={(e)=>e.preventDefault()} />
                                    </figure>
                                </a>
                            </div>
                            {/* image gallery end */}
                        </div>
                        <div className="col-lg-4 col-6">
                            {/* image gallery start */}
                            <div
                                className="photo-gallery wow fadeInUp"
                                data-wow-delay="0.8s"
                                data-cursor-text="View"
                            >
                                <a href="#!" onClick={(e) => { e.preventDefault(); openLightbox(4); }}>
                                    <figure className="image-anime protect-wrap">
                                        <img src="images/gallery-5.jpg" alt="Elegant home interior decoration" draggable={false} className="protect-img" onContextMenu={(e)=>e.preventDefault()} onDragStart={(e)=>e.preventDefault()} />
                                        <div className="image-protect-overlay" role="presentation" aria-hidden="true" onContextMenu={(e)=>e.preventDefault()} onMouseDown={(e)=>e.preventDefault()} onTouchStart={(e)=>e.preventDefault()} />
                                    </figure>
                                </a>
                            </div>
                            {/* image gallery end */}
                        </div>
                        <div className="col-lg-4 col-6">
                            {/* image gallery start */}
                            <div
                                className="photo-gallery wow fadeInUp"
                                data-wow-delay="1s"
                                data-cursor-text="View"
                            >
                                <a href="#!" onClick={(e) => { e.preventDefault(); openLightbox(5); }}>
                                    <figure className="image-anime protect-wrap">
                                        <img src="images/gallery-6.jpg" alt="Contemporary home interior design" draggable={false} className="protect-img" onContextMenu={(e)=>e.preventDefault()} onDragStart={(e)=>e.preventDefault()} />
                                        <div className="image-protect-overlay" role="presentation" aria-hidden="true" onContextMenu={(e)=>e.preventDefault()} onMouseDown={(e)=>e.preventDefault()} onTouchStart={(e)=>e.preventDefault()} />
                                    </figure>
                                </a>
                            </div>
                            {/* image gallery end */}
                        </div>
                        <div className="col-lg-4 col-6">
                            {/* image gallery start */}
                            <div
                                className="photo-gallery wow fadeInUp"
                                data-wow-delay="1.2s"
                                data-cursor-text="View"
                            >
                                <a href="#!" onClick={(e) => { e.preventDefault(); openLightbox(6); }}>
                                    <figure className="image-anime protect-wrap">
                                        <img src="images/gallery-7.jpg" alt="Luxury bedroom interior design" draggable={false} className="protect-img" onContextMenu={(e)=>e.preventDefault()} onDragStart={(e)=>e.preventDefault()} />
                                        <div className="image-protect-overlay" role="presentation" aria-hidden="true" onContextMenu={(e)=>e.preventDefault()} onMouseDown={(e)=>e.preventDefault()} onTouchStart={(e)=>e.preventDefault()} />
                                    </figure>
                                </a>
                            </div>
                            {/* image gallery end */}
                        </div>
                        <div className="col-lg-4 col-6">
                            {/* image gallery start */}
                            <div
                                className="photo-gallery wow fadeInUp"
                                data-wow-delay="1.4s"
                                data-cursor-text="View"
                            >
                                <a href="#!" onClick={(e) => { e.preventDefault(); openLightbox(7); }}>
                                    <figure className="image-anime protect-wrap">
                                        <img src="images/gallery-8.jpg" alt="Modern living space interior" draggable={false} className="protect-img" onContextMenu={(e)=>e.preventDefault()} onDragStart={(e)=>e.preventDefault()} />
                                        <div className="image-protect-overlay" role="presentation" aria-hidden="true" onContextMenu={(e)=>e.preventDefault()} onMouseDown={(e)=>e.preventDefault()} onTouchStart={(e)=>e.preventDefault()} />
                                    </figure>
                                </a>
                            </div>
                            {/* image gallery end */}
                        </div>
                        <div className="col-lg-4 col-6">
                            {/* image gallery start */}
                            <div
                                className="photo-gallery wow fadeInUp"
                                data-wow-delay="1.6s"
                                data-cursor-text="View"
                            >
                                <a href="#!" onClick={(e) => { e.preventDefault(); openLightbox(8); }}>
                                    <figure className="image-anime protect-wrap">
                                        <img src="images/gallery-9.jpg" alt="Beautiful home interior design" draggable={false} className="protect-img" onContextMenu={(e)=>e.preventDefault()} onDragStart={(e)=>e.preventDefault()} />
                                        <div className="image-protect-overlay" role="presentation" aria-hidden="true" onContextMenu={(e)=>e.preventDefault()} onMouseDown={(e)=>e.preventDefault()} onTouchStart={(e)=>e.preventDefault()} />
                                    </figure>
                                </a>
                            </div>
                            {/* image gallery end */}
                        </div>
                    </div>
                    {/* gallery section end */}
                </div>
            </div>
            {/* Photo Gallery Section End */}
            {lightboxOpen && (
                <Lightbox images={images} startIndex={startIndex} onClose={closeLightbox} />
            )}
        </>

    )
}

export default ImageGallery
